import { isNativeApp } from './pwa';

/**
 * Open a URL in the system browser when running as a native Capacitor app,
 * or navigate the current window when running on web.
 *
 * Used for billing/checkout flows so purchases happen outside the app
 * WebView — keeps us compliant with Google Play and App Store policies
 * that require in-app purchases for digital goods sold inside the app.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (isNativeApp()) {
    // Access the @capacitor/browser plugin via the Capacitor bridge.
    // The plugin is registered by the native shell (mobile/package.json),
    // so it's available at runtime in the WebView without being bundled
    // into the web app itself.
    const CapacitorBridge = (window as unknown as {
      Capacitor?: { Plugins?: { Browser?: { open: (opts: { url: string }) => Promise<void> } } };
    }).Capacitor;

    const Browser = CapacitorBridge?.Plugins?.Browser;
    if (Browser) {
      await Browser.open({ url });
      return;
    }
  }
  // Web fallback (also handles native fallback if Browser plugin unavailable)
  window.location.href = url;
}
